import {createReducer} from '@reduxjs/toolkit';

import {setAlertAction} from 'store/actions/alert-action';
import {AlertState} from 'store/types/app';

const initialState: AlertState = {
  type: undefined,
  details: undefined
};

const AlertReducer = createReducer(initialState, (builder) => {
  builder.addCase(setAlertAction, (state, action) => {
    return {
      ...state,
      type: action?.payload?.type,
      details: action?.payload?.details
    };
  });
});

export default AlertReducer;
